// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__pOFVGJbYDq{display:flex;align-items:center;gap:var(--dixa-size-spacer-100)}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/header/actionBar/conversationActionBar.module.scss"],"names":[],"mappings":"AAEA,kBACE,YAAA,CACA,kBAAA,CACA,+BAAA","sourcesContent":["@use '@dixa/lib-shared-tokens/scss' as *;\n\n.root {\n  display: flex;\n  align-items: center;\n  gap: var(--dixa-size-spacer-100);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__pOFVGJbYDq`
};
export default ___CSS_LOADER_EXPORT___;
